import * as R from 'ramda';

export default function ListItemDirective() {
  return {
    template: require('./list-item.html'),
    restrict: 'E',
    scope: {
      listTitle: '@',
      level: '<',
      flexTitle: '<',
      flexSummary: '<',
      flexActions: '<',
      truncate: '<',
    },
    transclude: {
      summary: '?summary',
      actions: '?actions',
    },
    link: (scope, attrs, el) => { // eslint-disable-line no-unused-vars
      if (R.isNil(scope.listItemVM.flexTitle)) {
        scope.listItemVM.flexTitle = 90;
      }
      if (R.isNil(scope.listItemVM.flexSummary)) {
        scope.listItemVM.flexSummary = 0;
      }
      if (R.isNil(scope.listItemVM.flexActions)) {
        scope.listItemVM.flexActions = 10;
      }
      // switch (scope.listItemVM.level) {
      //   case 1:
      //     scope.listItemVM.stylePrefix = 'inner-';
      //     break;
      //   case 2:
      //     scope.listItemVM.stylePrefix = 'sub-inner-';
      //     break;
      //   case 3:
      //     scope.listItemVM.stylePrefix = 'inner-sub-inner-';
      //     break;
      //   case 4:
      //     scope.listItemVM.stylePrefix = 'sub-inner-sub-inner-';
      //     break;
      //   default:
      //     scope.listItemVM.stylePrefix = '';
      // }
    },
    controller: () => { /* 'ListItemController' */ },
    controllerAs: 'listItemVM',
    bindToController: true,
    replace: true,
  };
}
